import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import tipsService from "../services/tipsService";

const initialState = {
  tipsIndexes: [],  // Lista de índices das dicas
  error: false,
  success: false,
  loading: false,
  message: null,
};

// Ação para buscar os índices das dicas por ChallengeId
export const getTipsIndexByChallengeId = createAsyncThunk(
  "tips/getIndex",
  async (data, thunkAPI) => {
    try {
      // Requisição para buscar as dicas
      const res = await tipsService.getTipsIndexByChallengeId(data);
      return res;  // Retorna os índices das dicas
    } catch (error) {
      // Se houver erro na requisição, retorna a mensagem de erro
      return thunkAPI.rejectWithValue("Erro ao buscar os índices das dicas");
    }
  }
);

export const getTipsIndexById = createAsyncThunk(
  "tips/getIndex",
  async (data, thunkAPI) => {
    try {
      // Requisição para buscar as dicas
      const res = await tipsService.getTipsIndexById(data);
      return res;  // Retorna os índices das dicas
    } catch (error) {
      // Se houver erro na requisição, retorna a mensagem de erro
      return thunkAPI.rejectWithValue("Erro ao buscar os índices das dicas");
    }
  }
);

export const purchase = createAsyncThunk(
  "tips/purchase",
  async (tip, thunkAPI) => {
    try {
      const data = await tipsService.purchase(tip);

      if (data.errors) {
        return thunkAPI.rejectWithValue(data.errors[0]); // Retorna a primeira mensagem de erro
      }

      return data;
    } catch (error) {
      // Lida com erros inesperados ou estrutura diferente
      const message =
        error.response?.data?.errors?.[0] || error.message || "Erro inesperado.";
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const tipsIndexesSlice = createSlice({
  name: "tipsIndexes",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(purchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(purchase.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tipsIndexes = action.payload;
        state.message = "Dicas listadas com sucesso!";
      })
      .addCase(purchase.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(getTipsIndexByChallengeId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTipsIndexByChallengeId.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tipsIndexes = action.payload;  // Atualiza a lista de índices
        state.message = "Dicas listadas com sucesso!";
      })
      .addCase(getTipsIndexByChallengeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.tips  // Armazena a mensagem de erro
      });
  },
});

export const { resetMessage } = tipsIndexesSlice.actions;
export default tipsIndexesSlice.reducer;
